import { getData as apiGetData } from 'api/Api'
import {
  setLoadStatus
} from '../redux/incomingMails'
import {
  add
} from 'store/redux/incomingMails'

type Payload = {
  cardId: number
}

export default (payload: Payload) => async (dispatch) => {
  const { cardId } = payload
  
  dispatch(setLoadStatus({
    cardId,
    isLoading: true,
    isLoaded: false
  }))

  try {
    const { Entries } = await apiGetData('CardIncomingMails', {
      cardId,
    })

    dispatch([
      ...Entries.map(IncomingMail => add({
        name: IncomingMail.Name,
        boardId: IncomingMail.BoardId,
        cardId: IncomingMail.CardId,
        cardTemplateId: IncomingMail.CardTemplateId,
        validateAddress: IncomingMail.ValidateAddress
      })),
      setLoadStatus({
        cardId,
        isLoading: false,
        isLoaded: true
      })
    ])
  } catch (error) {
    dispatch(setLoadStatus({
      cardId,
      isLoading: false,
      isLoaded: false
    }))
  }
}
